import React from 'react'
import {Header} from "../../../../header/Header";
import {FacilitatorHeader} from "../FacilitatorHeader";
import {MenuCell} from "../members/MenuCell";
import {Loading} from "../../../../ui/loading/Loading";
import {useSelector} from "react-redux";
import DataTable from "react-data-table-component";
import {SummaryCell} from "./SummaryCell";

export const ManageTools = () => {
    const router = useSelector((state:any) => state.router);
    let organization_id = router.selected_organization_id;
    let team_id = router.selected_team_id;
    const organization_team = useSelector((state:any) => state.organization_team);

    if(organization_team.isLoading) {
        return (
            <>
                <Header />
                <Loading />
            </>
        )
    }

    console.log("organization_team test", organization_team)

    const services = organization_team.data.services

    const columns = [
        {
            name: 'SKU',
            selector: (row: { SKU: any; }) => row.SKU,
            maxWidth: '10px'
        },
        {
            name: 'Tool/Level',
            selector: (row: { Name: any;}) => `${row.Name}`,
            maxWidth: '200px'
        },
        {
            name: 'Billing Cycle',
            selector: (row: { BillingCycle: any; }) => row.BillingCycle == undefined ? '' : row.BillingCycle,
            maxWidth: '150px'
        },
        {
            name: 'Base Fee',
            selector: (row: { BillingCycle: any; Fee:any; FeeY:any }) => `$${row.BillingCycle == 'Monthly' ? row.Fee : row.FeeY}`,
            maxWidth: '100px'
        },
        {
            name: 'Member Fee',
            selector: (row: { BillingCycle: any; FeeMember:any; FeeMemberY:any }) => `$${row.BillingCycle == 'Monthly' ? row.FeeMember : row.FeeMemberY}`,
            maxWidth: '100px'
        },
        {
            name: 'Basis',
            selector: (row: { Basis: any; }) => `${row.Basis}`,
            maxWidth: '200px'
        },
        {
            name: 'Summary',
            cell: (row: any) => <SummaryCell row={row}/>,
            allowOverflow: true
        }
    ];


    return (
        <>
            <Header />
            <div className="container">
                <div className="row mt-2 mb-5">
                    <div className="col-12 col-md-9">
                        <div className="row">
                            <FacilitatorHeader page_name={'Manage Team Suite'} />
                        </div>
                    </div>
                    <div className="col-12 mt-3">
                        <DataTable
                            columns={columns}
                            data={services}
                        />
                    </div>
                    <div className="col-12 mt-2 container" style={{backgroundColor: '#F6F6F6', borderBottom: 'solid 2px black'}}>
                        <div className="row mt-3">
                            <div className="col-1">Includes</div>
                            <div className="col-11">
                                <div dangerouslySetInnerHTML={{__html: services[0].Description}}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
